import { createFileRoute } from "@tanstack/react-router";
import { mcpConnectionsRoute } from "@/app-clients/app-shell/mcp-connections-route";

export const Route = createFileRoute("/api/mcp-connections")({
    ...mcpConnectionsRoute,
});
